import { render, staticRenderFns } from "./VariabilitySection.vue?vue&type=template&id=07704fa7&scoped=true&"
import script from "./VariabilitySection.vue?vue&type=script&lang=js&"
export * from "./VariabilitySection.vue?vue&type=script&lang=js&"
import style0 from "./VariabilitySection.vue?vue&type=style&index=0&id=07704fa7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07704fa7",
  null
  
)

export default component.exports